export enum RemoteApiErrorSeverity {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Warning = 'WARNING',
  Info = 'INFO',
}
